import { Form } from 'factorial-form'

class AssignEmployeesForm extends Form {
  constructor(values: object = {}) {
    super(values, {
      employee_id: 'number',
    })
  }
}

export default AssignEmployeesForm
